import { Injectable } from '@angular/core';
import { CR, JkEntityV2 } from 'jk-service';
import { Jckme } from '../entity/Jckme-angular';


export class JckmeLookup {
  dsME018 = [{ id: "上班", name: "上班" }, { id: "加班", name: "加班" }, { id: "假日", name: "假日" }];
  cboOrder = [{ id: "0", name: "時間+序號", order: " ORDER BY ME001,ME002" },
  ]; //
  constructor() {

  }
}

@Injectable({
  providedIn: 'root'
})
export class JackmeService<T> extends JkEntityV2 {
  constructor() {
    super();
    this.columnLabel = {
      COMPANY: "公司代號", CREATOR: "建檔者代號", USR_GROUP: "群組", CREATE_DATE: "建檔日期", MODIFIER: "修改者代號", MODI_DATE: "修改日期", FLAG: "更新次數",
      ME001: "時間", ME002: "序號", ME003: "說明", ME004: "檔名", ME005: "只做一次", ME006: "日期", ME010: "周日", ME011: "周一", ME012: "周二", ME013: "周三", ME014: "周四", ME015: "周五", ME016: "周六", ME017: "啟用", ME018: "模式"
    };
    //this.setFieldNames("COMPANY,CREATOR,USR_GROUP,CREATE_DATE,MODIFIER,MODI_DATE,FLAG,ME001,ME002,ME003,ME004,ME005,ME006,ME010,ME011,ME012,ME013,ME014,ME015,ME016,ME017,ME018");

    this.tableName = 'JCKME';
    this.isSys = false;
    this.sqlSelect = ' SELECT TOP 1000  ' + CR +
      '     JCKME.*  ' + CR +
      ' FROM JCKME  ' + CR +
      '    ';
    ;
    this.sqlWhereDefault = 'WHERE 1=1 ';
    this.sqlOrderDefault = ' ORDER BY ME001,ME002 ';
    this.keyFields = ['ME001', 'ME002'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['ME003'];
  }
  override getDefaultItem(): Jckme {
    //dummy = new Jckme();
    //return super.getDefaultItem(dummy);
    return new Jckme();
  }
  override async newRecord(newItem: Jckme): Promise<Jckme> {
    await super.newRecord(newItem);
    //newItem.WD001 = jkLib.nowDate() + "-" + jkLib.nowTime9();
    return newItem;
  }

}

